import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgIcon(props) {
  var _props$containerProps = props.containerProps,
      containerProps = _props$containerProps === void 0 ? {} : _props$containerProps,
      size = props.size,
      color = props.color,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      innerRef = props.innerRef,
      rest = _objectWithoutProperties(props, ["containerProps", "size", "color", "className", "style", "innerRef"]);

  var fill = !color && !props.fill ? '#1E79C2' : props.fill;
  var width = !size && !props.width ? 20 : props.width;
  var height = !size && !props.height ? 20 : props.height;

  var _convertPropToCssClas = convertPropToCssClassName('icon', className, {
    size: size,
    color: color
  }),
      cssClassName = _convertPropToCssClas.cssClassName;

  return /*#__PURE__*/React.createElement("span", _extends({
    ref: innerRef,
    className: cssClassName
  }, rest, containerProps, {
    style: _objectSpread({
      width: width,
      height: height
    }, style)
  }), /*#__PURE__*/React.createElement("svg", {
    width: width && String(width),
    height: height && String(height),
    fill: fill,
    style: {
      width: width,
      height: height
    },
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 15V5l5 5z"
  }))));
}

export default SvgIcon;
//# sourceMappingURL=ArrowheadRight.js.map
